export const getSlugGroupNameWithOrder = (currentGroupName: string, groupOrder: number): string => {
    const slug = '§';
    return [`${slug} ${groupOrder}`, currentGroupName].join('. ');
};
